(function($) {
	if ( $( '.news-archive__filter' ).length > 0 ) {
		$( '.news-archive__filter' ).each( function() {
			const chosen = $(this).find( '.news-archive__filter__chosen' ).text();
			$(this).find( '.news-archive__filter__list li' ).each( function() {
				if ( $( this ).find( 'a' ).text() === chosen ) {
					$( this ).addClass( 'selected' );
				}
			} );
		} );

		$( '.news-archive__filter__chosen' ).on( 'click', function() {
			$( this ).parent().toggleClass( 'open' );
		} );

		if ( -1 !== window.location.search.indexOf( 'news-year' ) ) {
			var parts = window.location.search.substr( 1 ).split( '&' );
			var $_GET = {};
			for (var i = 0; i < parts.length; i++) {
				var temp = parts[i].split("=");
				$_GET[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
			}
			$( '.news-archive__filter--caterories ul a' ).each( function() {
				const href = $( this ).attr( 'href' );
				let hash = '&news-year=';
				if ( -1 === href.indexOf( '?' ) ) {
					hash = '?news-year='
				}
				const hrefNew = href + hash + $_GET['news-year'];
				$( this ).attr( 'href', hrefNew );
			} );
		}
	}

})(jQuery);
